import React, { useRef, useState } from 'react'
import { Box, Container, IconButton, Input, Stack, Textarea, Button, Text, Flex, Heading, Link, Alert, AlertIcon } from '@chakra-ui/react'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { motion } from 'framer-motion'
import emailjs from '@emailjs/browser';

export default function Contact() {
  const formRef = useRef()
  const [ done, setDone ] = useState(null)

  function handleSubmit(e) {
    e.preventDefault();

    emailjs.sendForm('service_80so8dc', 'template_i8h2fve', formRef.current, '9OPq9T2tuxlBrrqau')
      .then((result) => {
          setDone(true);
          e.target.reset();
      })
      .catch((error) => {
          setDone(false);
      });      
  }

  return (
    <motion.div
      whileInView={{opacity: [0, 1]}}
      transition={{ duration: 0.5}}
    >
      <Box id='contact' p={10} >
        <Container maxW='container.lg' pt={14} pb={16} >
          <Heading as='h2' size='lg' noOfLines={1} pb={5}>Contact</Heading>

            {/* CONTACT FORM */}
              <Container maxW='container.md'>
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <Stack p={5} spacing={8}>
                      <Input type='text' focusBorderColor='pink.400' size='md' placeholder='Name' name='user_name' required/>

                      <Input type='email' focusBorderColor='pink.400' placeholder='Email' size='md' name='user_email' required/>

                      <Textarea focusBorderColor='pink.400' placeholder='Your message' size='md' name='message' required/>

                      <Button type='submit' bg='#ffc0cb'>Send</Button>

                    {done === true ? 
                      <Alert status='success' variant='solid'>
                          <AlertIcon />
                          Thank you! I will get back to you as soon as possibe!
                      </Alert>
                      :
                      done === false ?
                      <Alert status='error' variant='solid'>
                        <AlertIcon />
                        Something went wrong. Check if all inputs are complete.
                      </Alert>
                      : <></>
                    }
                    </Stack>                      
                  </form>
              </Container>
            

            <Container maxW='container.md' textAlign='center'>
              <Text variant='section-title' fontWeight='bold' pt={10} pb={4} fontSize='lg'>On the web</Text>
              <Flex justifyContent='center' alignItems='center' gap='4'>
                <Link href='https://github.com/macamrs' target='_blank'>
                  <IconButton variant='ghost' size='lg' fontSize='20px' isRound='true' icon={<FaGithub />} />
                </Link>

                <Link href='https://www.linkedin.com/in/macarena-singh/' target='_blank'>
                  <IconButton variant='ghost' size='lg' fontSize='20px' isRound='true' icon={<FaLinkedin />} />
                </Link>          
              </Flex>
            </Container>
        </Container>
      </Box>      
    </motion.div>

  )
}